import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  NavigationLocation,
  NextPageService,
  PageLayout,
  SearchType,
  SliderType
} from '@cvx/nextpage';
import { AppConfig } from './services/app-config.service';
import { IdleDetectService } from './services/idle.service';
import { CalService } from './auth/cal.service';
import { environment } from 'src/environments/environment';
import { commonService } from './services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  SearchType = SearchType;
  SliderType = SliderType;
  welcomeName = '';
  apiUrl = AppConfig.settings.apiUrl;
  title = 'Emdm CMMS';
  httpOptions: any = "";

  logoutWarningPopupShow = false;
  idleLogoutContentShow = false;
  idleWarningContentShow = false;

  redirectURL = "";
  constructor(
    private NP: NextPageService,
    private router: Router,
    private idleService$: IdleDetectService,
    private commonService: commonService) {
    this.NP.options.sitename = 'Emdm CMMS UI';
  }

  async ngOnInit() {
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }

      if ((event instanceof NavigationEnd)) {
        if (this.commonService.prevNotification != null) {
          if (this.commonService.prevNotificationCanCloseByNavigation) {
            this.commonService.prevNotification.hide();
            this.commonService.prevNotification = null;
            this.commonService.prevNotificationType = 'none';
            this.commonService.prevNotificationMessage = '';
          } else {
            this.commonService.prevNotificationCanCloseByNavigation = true;
          }
        }

        if (event.url?.toLocaleLowerCase() == '/' || (event.url?.toLocaleLowerCase().includes('dashboard') && !event.url?.toLocaleLowerCase().includes('reporting-dashboard'))) {
          document.documentElement.style.setProperty('--display-hide-flex', 'none');
        } else {
          document.documentElement.style.setProperty('--display-hide-flex', 'flex');
        }
      }

      window.scrollTo(0, 0);
    });

    if (!sessionStorage.getItem('userIsActive')) {
      sessionStorage.setItem('userIsActive', 'true');
    }
    
    this.idleService$.idleState.subscribe((status: any) => {
      if (status) {
        if (status == 'Warning') {
          this.logoutWarningPopupShow = true;
          this.idleWarningContentShow = true;
          this.idleLogoutContentShow = false;
        }
        else if (status == 'Timeout') {
          this.logoutWarningPopupShow = true;
          this.idleWarningContentShow = false;
          this.idleLogoutContentShow = true;
          sessionStorage.clear();
          localStorage.clear();
        }
        else if (status == 'Active') {
          this.logoutWarningPopupShow = false;
          this.idleWarningContentShow = false;
          this.idleLogoutContentShow = false;
        }
      }
    });

    this.commonService.userIsActive.subscribe((status: any) => {
      if (status != null && !status) {
        // this.router.navigate(['invalid-permission']);
      }
    });
  }

  ngAfterViewInit() {
    this.redirectURL = environment.calSettings.redirectUri ?? "";
  }
}